import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth-store'

interface ProtectedRouteProps {
  children: React.ReactNode
}

/**
 * Protected route wrapper component
 * Checks authentication status and redirects to login if not authenticated
 * Preserves the intended destination for post-login redirect
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation()
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const isTokenExpired = useAuthStore((state) => state.isTokenExpired)

  // Check if user is authenticated and token is valid
  const hasValidSession = isAuthenticated && !isTokenExpired()

  if (!hasValidSession) {
    // Save the current location so we can redirect back after login
    // Store in sessionStorage to persist across page reloads
    sessionStorage.setItem('intended_destination', location.pathname + location.search)

    // Redirect to login page
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  // User is authenticated, render the protected content
  return <>{children}</>
}

export default ProtectedRoute
